// pages/Vehicles.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "../components/DataTable";
import API from "../config/config";

const VehicleTypes = () => {
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVehicleTypes = async () => {
      try {
        const response = await axios.get(API.ADMIN.VEHICLE_TYPE_LIST);
        setVehicleTypes(response.data.vehicleTypes);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchVehicleTypes();
  }, []);

  const handleDelete = async (vehicleTypeId) => {
    try {
      await axios.delete(`${API.ADMIN.VEHICLE_TYPE_DELETE}/${vehicleTypeId}`);
      setVehicleTypes(
        vehicleTypes.filter((vehicleType) => vehicleType._id !== vehicleTypeId)
      );
    } catch (error) {
      console.error("Error deleting vehicle:", error);
    }
  };

  const columns = [
    { Header: "Type", accessor: "type" },
    { Header: "Sub-Type", accessor: "subtype" },
  ];

  return (
    <DataTable
      data={vehicleTypes}
      columns={columns}
      loading={loading}
      addLink="/vehicleTypes/add"
      editPath="/vehicleTypes/edit"
      detailPath="/vehicleTypes/detail"
      deleteHandler={handleDelete}
    />
  );
};

export default VehicleTypes;
